import { render, staticRenderFns } from "./RiverBasins.vue?vue&type=template&id=56ec04d9&"
import script from "./RiverBasins.vue?vue&type=script&lang=js&"
export * from "./RiverBasins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports